import { combineReducers } from "redux";
import setPasswordReducer from "./activationPage/reducers";
import addTenantUserReducer from "./addTenantUser/reducers";
import signinReducer from "./signin/reducers";
import signupReducer from "./signup/reducers";
import tenantsReducer from "./tenant/reducers";
import tenantUserListReducer from "./tenantUserList/reducers";
import productReducer from "./product/reducers";
import createProductReducer from "./createprod/reducers";
import CheckoutReducer from "./checkout/reducers";

const rootReducer = combineReducers({
  signupReducer,
  setPasswordReducer,
  tenantsReducer,
  tenantUserListReducer,
  signinReducer,
  addTenantUserReducer,
  productReducer,
  createProductReducer,
  CheckoutReducer,
});

export default rootReducer;
